import { connect } from 'react-redux';

import LearningAdminHeaderList from '../components/LearningAdminHeaderList';
import storage from '../../../../../lib/Storage';

const mapStateToProps = (state, ownProps) => {
  return {
    partnershipId: storage.get('local', 'partnershipId'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

const LearningAdminHeaderListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminHeaderList);

export default LearningAdminHeaderListContainer;
